import { combineReducers } from "redux";

import benchmarks from "./../redux/benchmarks";
import bestWorst from "./../redux/bestWorst";
import domainScores from "./../redux/domainScores";
import keyDrivers from "./../redux/keyDrivers";
import magnetFooter from "./../redux/magnetFooter";
import magnetReport from "./../redux/magnetReport";
import magnetWorkSetting from "./../redux/magnetWorkSetting";
import magnetWorkSettings from "./../redux/magnetWorkSettings";
import observations from "../redux/observations";
import questions from "../redux/questions";
import scatterPlots from "../redux/scatterPlots";
import summaryReport from "./../redux/summaryReport";
import summaryReportTree from "./../redux/summaryReportTree";
import user from "../redux/user";
import nav from "../redux/nav";
import filters from "../redux/filters";

export default combineReducers({
  benchmarks,
  bestWorst,
  domainScores,
  keyDrivers,
  magnetFooter,
  magnetReport,
  magnetWorkSetting,
  magnetWorkSettings,
  observations,
  questions,
  scatterPlots,
  summaryReport,
  summaryReportTree,
  user,
  nav,
  filters,
});



// WEBPACK FOOTER //
// ./src/config/reducers.js